import React, { useEffect } from 'react';
import FacilityStore from './../stores/FacilityStore';
import ViewerStore from './../stores/ViewerStore';
import * as Inovx from '@shared';
import FacilityMap from './FacilityMap';
import OntologyDropDown from './OntologyDropDown';
import ContentLayersButton from '../viewers/viewer/ContentLayersButton';
import { ContentLayers } from '../Interfaces/ViewerInterfaces';
import { isBlackAndWhiteScanPosition, isScanPositionView } from '../helpers/viewMedia';

interface IFacilityMapViewProps {
    openViewHandler?: (view: IView360Detail, index: number) => void;
}

const FacilityMapView: React.FC<IFacilityMapViewProps> = ({openViewHandler}) => {
    const [selectedFacility, setSelectedFacility] = React.useState<IFacilityDetail>(FacilityStore.getSelectedFacility());
    const [selectedOntology, setSelectedOntology] = React.useState<IOntologyPart>(FacilityStore.getSelectedOntology());
    const [contentLayers, setContentLayers] = React.useState<ContentLayers>(() => ViewerStore.getContentLayers());
    
    useEffect(() => {
        loadState();
        FacilityStore.addChangeListener(loadState);
        ViewerStore.addChangeListener(loadViewerState);

        return () => {
            FacilityStore.removeChangeListener(loadState);
            ViewerStore.removeChangeListener(loadViewerState);
        };
    }, []);

    const loadViewerState = () => {
        setContentLayers(ViewerStore.getContentLayers());
    };

    const loadState = () => {
        const selectedFacility = FacilityStore.getSelectedFacility();
        const selectedOntology = FacilityStore.getSelectedOntology() ?? FacilityStore.getRootOntologyPart();

        setSelectedFacility(selectedFacility);
        setSelectedOntology(selectedOntology);
    };

    const hasOntologyHierarchy = selectedFacility?.OntologyParts?.length > 1;
    const hasSiteMap = selectedOntology?.Map?.MapFileImageUrl;
    const visibleViews = React.useMemo(() => {
        if (!contentLayers.positions360) return [];

        return (selectedFacility?.Views ?? []).filter(view => isScanPositionView(view)
            ? (isBlackAndWhiteScanPosition(view)
                ? contentLayers.blackAndWhiteScanPositions
                : contentLayers.colorScanPositions)
            : contentLayers.imagePositions);
    }, [selectedFacility?.Views, contentLayers.positions360, contentLayers.colorScanPositions, contentLayers.blackAndWhiteScanPositions, contentLayers.imagePositions]);
    
    return (
        <div className="h-100p position-relative">
            {hasOntologyHierarchy && <OntologyDropDown selectedOntology={selectedOntology} readonly={false} />}
            {hasSiteMap && <ContentLayersButton positionsOnly={true} />}

            {hasSiteMap ? <FacilityMap
                siteMap={selectedOntology.Map}
                views={visibleViews}
                showElements={true}
                onViewMarkerClicked={openViewHandler}
                key={selectedOntology.ID}
            />
                : <div className="new-facility-map">
                    <h3>{InovxLoader.t("facility:message.noMapImageUploaded")}</h3>
                </div>
            }
        </div>
    );
};

export default FacilityMapView;
